/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import React, {useEffect} from 'react';
import Tab from '@mui/material/Tab';
import {Link, useLocation, useRouteMatch} from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import appTheme from '../common/theme/appTheme.json';
import {TabConfig} from './ProvisioningContainer';

export interface TabConfigProps {
  tabs: TabConfig[];
}

const ProvisioningTabMenu = (props: TabConfigProps) => {
  const { url } = useRouteMatch();
  const { pathname: curPath } = useLocation();

  const [curTab, setCurTab] = React.useState(props.tabs[0].route);
  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setCurTab(newValue);
  };

  useEffect(() => {
    // Ensure the correct tab is active based on the current URL
    const matchingTab = props.tabs.find(tab => {
      const regex = new RegExp(`^${url}/${tab.route}(/.+)?$`);
      return regex.test(curPath);
    });
    if (matchingTab) {
      setCurTab(matchingTab.route);
    }
  }, [curPath, props.tabs, url]);

  return (
    <Tabs
      value={curTab}
      onChange={handleTabChange}
      role={'navigation'}
      sx={{ '* .MuiTabs-indicator': { backgroundColor: appTheme.selectedTabHighlightColor } }}
    >
      {props.tabs.map(tabConfig => (
        <Tab
          to={`${url}/${tabConfig.route}`}
          value={tabConfig.route}
          key={tabConfig.route}
          label={tabConfig.title}
          component={Link}
          sx={{
            color: appTheme.primaryTextColor,
            textTransform: 'unset',
            fontWeight: '600',
            '&.Mui-selected': {
              color: appTheme.primaryTextColor,
            },
          }}
        />
      ))}
    </Tabs>
  );
};

export default ProvisioningTabMenu;
